import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';

class PageNotFound extends Component {
  render() {
    const { t } = this.props;
    return (
      <div className="common-page-not-found">
        { t('page_not_found.message') }
      </div>
    );
  }
}

export default withNamespaces('common')(PageNotFound);


// WEBPACK FOOTER //
// ./src/features/common/PageNotFound.js